import { render, staticRenderFns } from "./GroupDisplay.vue?vue&type=template&id=bb38d0dc&scoped=true&lang=html&"
import script from "./GroupDisplay.vue?vue&type=script&lang=js&"
export * from "./GroupDisplay.vue?vue&type=script&lang=js&"
import style0 from "./GroupDisplay.vue?vue&type=style&index=0&id=bb38d0dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb38d0dc",
  null
  
)

export default component.exports